// Effective client-portal permissions for the logged-in caller.
//
// The /auth/me payload (cached in localStorage as `client_user`) carries a
// `client_context` for wholesale callers: { is_owner, account_role, permissions }.
// Account OWNERS (and admins impersonating a client) have full capabilities;
// invited TEAM MEMBERS are limited to their stored permission flags. Server-side
// enforcement is authoritative (client_user_service.require_client_permission);
// these helpers only drive which buttons the UI shows.

const FULL_PERMISSIONS = {
  isOwner: true,
  can_place_orders: true,
  can_view_invoices: true,
  can_pay_invoices: true,
  can_edit_profile: true,
  can_manage_users: true,
  can_view_reports: true,
};

export const getClientPermissions = () => {
  try {
    const u = JSON.parse(localStorage.getItem('client_user') || '{}');
    if (u.role === 'admin') return { ...FULL_PERMISSIONS };

    const ctx = u.client_context;
    // No explicit team-member context → treat as owner (safe default; owners
    // always have a context with is_owner=true).
    if (!ctx || ctx.is_owner) return { ...FULL_PERMISSIONS };

    const p = ctx.permissions || {};
    return {
      isOwner: false,
      can_place_orders: !!p.can_place_orders,
      can_view_invoices: p.can_view_invoices !== false,
      can_pay_invoices: !!p.can_pay_invoices,
      can_edit_profile: !!p.can_edit_profile,
      can_manage_users: !!p.can_manage_users,
      can_view_reports: p.can_view_reports !== false,
    };
  } catch {
    return { ...FULL_PERMISSIONS };
  }
};
